<div class="mb-3 d-flex align-items-center gap-2">
  <label for="leadSourceFilter" class="form-label mb-0 text-nowrap fw-semibold">
    <i class="ti ti-broadcast me-1"></i>Source
  </label>
  <select
    id="leadSourceFilter"
    class="form-select form-select-sm w-auto"
    [(ngModel)]="selectedLeadSource"
    (change)="onLeadSourceChange()">
    <option *ngFor="let opt of leadSourceOptions" [ngValue]="opt.value || undefined">
      {{ opt.label }}
    </option>
  </select>
</div>

<ul ngbNav #nav="ngbNav" [(activeId)]="activeNav" (activeIdChange)="onTabChange($event)" class="nav-tabs">
  <li [ngbNavItem]="0">
    <button ngbNavLink>{{'All' }}</button>
    <ng-template ngbNavContent>
      <app-pagination-row (onLoad)="onPaginationLoad($event)" [initialPageSize]="pageSize"
        [initialSearchQuery]="searchQuery"></app-pagination-row>

      <app-table *ngIf="viewStatus === ViewStatus.LOADING || (leads?.length ?? 0) > 0  " [rowClickable]="true"
        (onRowClicked)="navigateToDetails($event)" (pageChange)="onPageChange($event)" [status]="viewStatus"
        [showPagination]="true" [paginationInfo]="leadsPaginationInfo" [columns]="columns" [showToolbar]="false"
        (onSortingChanged)="onSortingChanged($event)" [dataList]="leads">
      </app-table>

      <app-empty-state *ngIf="viewStatus === ViewStatus.READY && (!leads || leads.length === 0)"
        [title]="'No leads found' "
        [message]="'There are no leads at the moment. New leads will appear here when available.' "
        iconPath="/assets/emptyIcon.png">
      </app-empty-state>
    </ng-template>
  </li>

  <li [ngbNavItem]="1">
    <button ngbNavLink>{{'Verified' }}</button>
    <ng-template ngbNavContent>
      <app-pagination-row (onLoad)="onPaginationLoad($event)" [initialPageSize]="pageSize"
        [initialSearchQuery]="searchQuery"></app-pagination-row>

      <app-table *ngIf=" viewStatus === ViewStatus.LOADING || (leads?.length ?? 0) > 0" [rowClickable]="true"
        (onRowClicked)="navigateToDetails($event)" (pageChange)="onPageChange($event)" [showToolbar]="false"
        [status]="viewStatus" [showPagination]="true" [paginationInfo]="leadsPaginationInfo" [columns]="columns"
        [showToolbar]="false" (onSortingChanged)="onSortingChanged($event)" [dataList]="leads">
      </app-table>

      <app-empty-state *ngIf="viewStatus === ViewStatus.READY && (!leads || leads.length === 0)"
        [title]="'No verified leads'  "
        [message]="'There are no verified leads yet. Verified leads will be displayed here.' "
        iconPath="/assets/emptyIcon.png">
      </app-empty-state>
    </ng-template>
  </li>

  <li [ngbNavItem]="2">
    <button ngbNavLink>{{'Not verified' }}</button>
    <ng-template ngbNavContent>
      <app-pagination-row (onLoad)="onPaginationLoad($event)" [initialPageSize]="pageSize"
        [initialSearchQuery]="searchQuery"></app-pagination-row>

      <app-table *ngIf="  viewStatus === ViewStatus.LOADING || (leads?.length ?? 0) > 0" [rowClickable]="true"
        (onRowClicked)="navigateToDetails($event)" (pageChange)="onPageChange($event)" [status]="viewStatus"
        [showPagination]="true" [paginationInfo]="leadsPaginationInfo" [columns]="columns" [showToolbar]="false"
        (onSortingChanged)="onSortingChanged($event)" [dataList]="leads">
      </app-table>

      <app-empty-state *ngIf="viewStatus === ViewStatus.READY && (!leads || leads.length === 0)"
        [title]="'No unverified leads'  "
        [message]="'There are no unverified leads at the moment. Unverified leads will be displayed here when available.' "
        iconPath="/assets/emptyIcon.png">
      </app-empty-state>
    </ng-template>
  </li>
</ul>

<div class="nav-content" [ngbNavOutlet]="nav"></div>
